import { SET_DATA_ROUTE_FOR_EDIT, SET_MESSAGE_SAVE_STATE_ROUTE } from 'orden_express/routes/routesActions.js';
import { REQUEST_RESET_STATE_ROUTES, RESPONSE_GET_ROUTES, RESPONSE_SAVE_ROUTE } from 'orden_express/routes/routesEpic.js';


const initialState = {
    dataRouteForEdit: null,
    responseSaveRoute: {},
    messageSaveStateRoute: 0,
    responseGetRoutes: {},
};

const routesReducer = (state = initialState, action) => {
    switch (action.type) {

        case REQUEST_RESET_STATE_ROUTES:
            return {
                ...state,
                dataRouteForEdit: null,
                responseSaveRoute: {},
                messageSaveStateRoute: 0,
                responseGetRoutes: {},

            };

        case SET_DATA_ROUTE_FOR_EDIT:
            return {
                ...state,
                dataRouteForEdit: action.dataRouteForEdit,

            };

        case RESPONSE_GET_ROUTES:
            return {
                ...state,
                responseGetRoutes: action.responseGetRoutes,

            };

        case RESPONSE_SAVE_ROUTE:
            return {
                ...state,
                responseSaveRoute: action.responseSaveRoute,
                messageSaveStateRoute: action.responseSaveRoute.errorState === true ? 3 : 2,
            };

        case SET_MESSAGE_SAVE_STATE_ROUTE:
            return {
                ...state,
                messageSaveStateRoute: action.messageSaveStateRoute
            };

        default:
            return state;
    }
}

export default routesReducer;